export const buyTogetherLabels = {
  selectedAll: 'Seleccionar todos',
  product: 'producto',
  products: 'productos',
  addSelectedProducts: 'Agregar al Carro',
  seeMore: 'Mostrar más',
  seeLess: 'Mostrar menos',
  cartWarningDesktop: 'Agrega al menos un producto.',
  cartWarningMobile: 'Elige al menos un producto para agregarlo al Carro.',
  recommendedUnitsSingular: 'unidad recomendada',
  recommendedUnitsPlural: 'unidades recomendadas',
  tooltipMessage: 'Según tu producto principal, para tu proyecto te sugerimos esta cantidad de unidades.',
  tooltipCloseButton: 'Entendido',
};

const standAloneTenant = {
  so_com: {
    cl: 'SOCL',
    co: 'SOCO',
    pe: 'SOPE',
  },
  so_retail: {
    mx: 'SOMX',
  },
};

const defaultTenant = {
  cl: 'FACL',
  co: 'FACO',
  pe: 'FAPE',
  ar: 'FAAR',
  mx: 'SOMX',
};

export function getTenantValue(store, key) {
  return standAloneTenant[store]?.[key] || defaultTenant[key];
}
